import { render, staticRenderFns } from "./ClinicInformation.vue?vue&type=template&id=311bbc3a"
import script from "./ClinicInformation.vue?vue&type=script&lang=js"
export * from "./ClinicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports